export const XstreamResetStreamingStateActionName = 'XSTREAM_RESET_STREAMING_STATE'
export const XstreamSetStreamingChartFrequencyActionName = 'XSTREAM_SET_CHART_FREQUENCY'

export const XstreamResetStreamingStateAction = () => ({ type: XstreamResetStreamingStateActionName })

export const XstreamSetStreamingChartFrequencyInMinutes = (minutes: number) => ({ data: minutes, type: XstreamSetStreamingChartFrequencyActionName })